import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import './SidebarProcesosSeleccion.css';

const NAV_ITEMS = [
  {
    path: '/nuevosPostulantes',
    title: 'Postulantes',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
        <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z"/>
      </svg>
    )
  },
  {
    path: '/evaluacionesProcesos',
    title: 'Evaluaciones',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
        <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm7 13H5v-.23c0-.62.28-1.2.76-1.58C7.47 15.82 9.64 15 12 15s4.53.82 6.24 2.19c.48.38.76.97.76 1.58V19z"/>
      </svg>
    )
  },
  {
    path: '/reportesTCN',
    title: 'Reportes',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
        <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 14H7v-2h5v2zm3-4H7v-2h8v2zm0-4H7V7h8v2z"/>
      </svg>
    )
  }
];

const SidebarProcesosSeleccion = () => {
  const history = useHistory();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);

  return (
    <aside className={`sidebar-procesos${collapsed ? ' sidebar-procesos--collapsed' : ''}`}>
      <div className="sidebar-procesos__nav">
        {NAV_ITEMS.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <button
              key={item.title}
              className={`sidebar-procesos__item ${isActive ? 'sidebar-procesos__item--active' : ''} ${item.isDisabled ? 'sidebar-procesos__item--disabled' : ''}`}
              onClick={() => {
                if (!item.isDisabled && item.path) {
                  history.push(item.path);
                }
              }}
              disabled={item.isDisabled}
              title={item.title}
            >
              <span className="sidebar-procesos__icon">{item.icon}</span>
              <span className="sidebar-procesos__label">{item.title}</span>
            </button>
          );
        })}
      </div>
      <button
        className="sidebar-procesos__toggle"
        onClick={() => setCollapsed(!collapsed)}
        title={collapsed ? 'Expandir menú' : 'Colapsar menú'}
        aria-label={collapsed ? 'Expandir menú lateral' : 'Colapsar menú lateral'}
      >
        <svg
          viewBox="0 0 24 24"
          fill="currentColor"
          width="13"
          height="13"
          style={{ transform: collapsed ? 'rotate(180deg)' : 'none', transition: 'transform 0.25s ease' }}
        >
          <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z" />
        </svg>
      </button>
    </aside>
  );
};

export default SidebarProcesosSeleccion;
